var modPrivateZoneMenuModule = function(){
    var scope = ".js-mod-private-zone-menu";
    ui.ready(
        scope,
        function($menu){
           $menu.find(scope+"__logout").click(
                function(ev){
                    ev.preventDefault();
                    gvf.endpoint(
                        "web\\loginController::logout",
                        [],
                        function(response){
                            if(response.status=="ok"){
                                window.location = response.url;
                            }
                        }
                    );
                }
           );

           $menu.find(scope+"__href").each(
                function(ev){
                    if($(this).attr("href") == window.location.pathname){
                        $(this).addClass("is-active");
                    }
                }
            );
        }
    );
}();

